import { render } from "./MemberAside.vue?vue&type=template&id=1b2ef8b3&scoped=true"
import script from "./MemberAside.vue?vue&type=script&lang=js"
export * from "./MemberAside.vue?vue&type=script&lang=js"

import "./MemberAside.vue?vue&type=style&index=0&id=1b2ef8b3&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2ef8b3"]])

export default __exports__